export function importAll(r) {
  r.keys().forEach(r);
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}